import { render, staticRenderFns } from "./ResultsOverall.vue?vue&type=template&id=2ea9ea42&scoped=true&"
import script from "./ResultsOverall.vue?vue&type=script&lang=js&"
export * from "./ResultsOverall.vue?vue&type=script&lang=js&"
import style0 from "./ResultsOverall.vue?vue&type=style&index=0&id=2ea9ea42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9ea42",
  null
  
)

export default component.exports